export class ResetPasswordModel {
    email: string;
    password: string;
    confirmPassword: string;
    token: string;
}